import { TaxInfo } from '../../types/mutual-fund-detail.types'

export interface TaxLiabilityCalculation {
  preTaxValue: number
  stcgTax: number
  ltcgTax: number
  totalTaxLiability: number
  postTaxValue: number
}

export const calculateTaxLiability = (
  withdrawalAmount: number,
  exitLoad: number,
  stcgInfo: TaxInfo,
  ltcgInfo: TaxInfo
): TaxLiabilityCalculation => {
  // Pre-Tax Value = Withdrawal Amount - Exit Load
  const preTaxValue = withdrawalAmount - exitLoad

  // Calculate STCG Tax = STCG Taxable Amount (from API)
  const stcgTax = stcgInfo?.taxableAmount ?? 0

  // Calculate LTCG Tax = LTCG Taxable Amount (from API)
  const ltcgTax = ltcgInfo?.taxableAmount ?? 0

  // Total Tax Liability = STCG Tax + LTCG Tax
  const totalTaxLiability = stcgTax + ltcgTax

  // Post-Tax Value = Pre-Tax Value - Total Tax Liability
  const postTaxValue = preTaxValue - totalTaxLiability

  return {
    preTaxValue,
    stcgTax,
    ltcgTax,
    totalTaxLiability,
    postTaxValue
  }
}
